import React, { ReactNode } from 'react'

export interface OraclePillButtonProps {
  children: ReactNode
  onClick?: () => void
  className?: string
  selected?: boolean
  type?: 'button' | 'submit' | 'reset'
  disabled?: boolean
  ariaLabel?: string
  ariaPressed?: boolean
}

export const OraclePillButton: React.FC<OraclePillButtonProps> = ({
  children,
  onClick,
  className = '',
  selected = false,
  type = 'button',
  disabled = false,
  ariaLabel,
  ariaPressed,
}) => {
  const classes = [
    'oracle-pill-button',
    className,
    selected ? 'oracle-pill-button--selected' : '',
  ].filter(Boolean).join(' ')

  return (
    <button
      type={type}
      className={classes}
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel}
      aria-pressed={ariaPressed}
    >
      {children}
    </button>
  )
}
